import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  updateLaptopQuizPageCurrentStep,
  incrementLaptopQuizPageCurrentStep,
  updateLaptopQuizPageStep1,
  updateLaptopQuizPageStep2,
  updateLaptopQuizPageStep3,
  updateLaptopQuizPageStep4,
  updateLaptopQuizPageFiltersSquished
} from '../../reducers/laptopQuizPageReducer';
import {Progress, Icon, Button, Input, Label} from 'semantic-ui-react';

import './LaptopQuizPage.css';

class LaptopQuizPage extends Component {
  constructor(props) {
    super(props);

    window.mixpanel.track('LaptopQuizPage Visited', {
    });

    this.handleStep1ButtonClick = this.handleStep1ButtonClick.bind(this);
    this.handleStep1NextButtonClick = this.handleStep1NextButtonClick.bind(this);
    this.handleStep2ButtonClick = this.handleStep2ButtonClick.bind(this);
    this.handleStep2NextButtonClick = this.handleStep2NextButtonClick.bind(this);
    this.handleStep3ButtonClick = this.handleStep3ButtonClick.bind(this);
    this.handleStep3NextButtonClick = this.handleStep3NextButtonClick.bind(this);
    this.handleStep4AttributesButtonClick = this.handleStep4AttributesButtonClick.bind(this);
    this.handleStep4ColorsButtonClick = this.handleStep4ColorsButtonClick.bind(this);
    this.handleStep4DoneButtonClick = this.handleStep4DoneButtonClick.bind(this);
    this.handleBrandTextBoxChange = this.handleBrandTextBoxChange.bind(this);
    this.toggleSelectedAndDeselectEverythingElse = this.toggleSelectedAndDeselectEverythingElse.bind(this);
  }

  handleStep1ButtonClick(event, data) {
    const currentStep1 = this.props.step1.slice();
    currentStep1[data.name]['selected'] = !currentStep1[data.name]['selected'];
    this.props.updateLaptopQuizPageStep1(currentStep1);
  }

  handleStep1NextButtonClick(event, data) {
    window.mixpanel.track('Step1 Next Clicked', {
    });

    document.getElementById('Step2Heading').scrollIntoView({block: 'start', behavior: 'smooth'});
  }

  handleStep2ButtonClick(event, data) {
    const currentStep2 = this.props.step2.slice();
    currentStep2[data.name]['selected'] = !currentStep2[data.name]['selected'];
    this.props.updateLaptopQuizPageStep2(currentStep2);
  }

  handleStep2NextButtonClick(event, data) {
    window.mixpanel.track('Step2 Next Clicked', {
    });

    document.getElementById('Step3Heading').scrollIntoView({block: 'start', behavior: 'smooth'});
  }

  handleStep3ButtonClick(event, data) {
    let currentStep3 = this.props.step3.slice();
    // if selecting "I don't care", deselect all others
    // if selecting all others, deselect "I don't care"
    // else regular behavior
    if (!data.name && !currentStep3[data.name]['selected']) {
      currentStep3 = this.toggleSelectedAndDeselectEverythingElse(currentStep3, 0);
    } else if (data.name && !currentStep3[data.name]['selected']) {
      currentStep3[0].selected = false;
      currentStep3[data.name]['selected'] = !currentStep3[data.name]['selected'];
    } else {
      currentStep3[data.name]['selected'] = !currentStep3[data.name]['selected'];
    }
    this.props.updateLaptopQuizPageStep3(currentStep3);
  }

  handleStep3NextButtonClick(event, data) {
    window.mixpanel.track('Step3 Next Clicked', {
    });

    const currentStep3 = this.props.step3.slice();
    if (this.props.step3[5].selected &&
        !this.props.step3[5].otherValue.trim()) {
      // Other is selected but no valid value is entered
      currentStep3[5]['errorState'] = true;
      this.props.updateLaptopQuizPageStep3(currentStep3);
    } else {
      currentStep3[5]['errorState'] = false;
      this.props.updateLaptopQuizPageStep3(currentStep3);
      document.getElementById('Step4Heading').scrollIntoView({block: 'start', behavior: 'smooth'});
    }
  }

  handleStep4AttributesButtonClick(event, data) {
    const currentStep4 = {...this.props.step4};
    const currentStep4Attributes = currentStep4.attributes.slice();
    currentStep4Attributes[data.name]['selected'] = !currentStep4Attributes[data.name]['selected'];
    this.props.updateLaptopQuizPageStep4(currentStep4);
  }

  handleStep4ColorsButtonClick(event, data) {
    const currentStep4 = {...this.props.step4};
    // You can select either 1 or 0 colors at a time
    currentStep4.colors = this.toggleSelectedAndDeselectEverythingElse(currentStep4.colors, data.name);
    this.props.updateLaptopQuizPageStep4(currentStep4);
  }

  handleStep4DoneButtonClick(event, data) {

    // create raw list of all filters
    const filtersOptimized = {
      ramSize: {min: 0, max: 10000000},
      hardDriveType: '',
      hardDriveSpace: {min: 0, max: 10000000},
      screenSize: {min: 0, max: 10000000},
      screenType: '',
      cpuCores: {min: 0, max: 10000000},
      gpuType: '',
      weight: {min: 0, max: 10000000},
      touchscreen: false,
      budgets: [],
      brands: [],
      color: ''
    };

    const ramSizes = [];
    const hardDriveTypes = [];
    const hardDriveSpaces = [];
    const screenSizes = [];
    const screenTypes = [];
    const cpuCores = [];
    const gpuTypes = [];
    const weights = [];
    const touchscreens = [];
    const budgets = [];
    const brands = [];
    const colors = [];

    // check for choices selected and populate filter accordingly

    // step1
    for (const f of this.props.step1) {
      if (f.selected) {
        for (const cat of this.props.filterCategories[f.filterName]) {
          switch (cat.type) {
            case 'ramSize':
              ramSizes.push(cat);
              break;
            case 'hardDriveType':
              hardDriveTypes.push(cat);
              break;
            case 'hardDriveSpace':
              hardDriveSpaces.push(cat);
              break;
            case 'screenSize':
              screenSizes.push(cat);
              break;
            case 'screenType':
              screenTypes.push(cat);
              break;
            case 'cpuCores':
              cpuCores.push(cat);
              break;
            case 'gpuType':
              gpuTypes.push(cat);
              break;
            case 'weight':
              weights.push(cat);
              break;
            case 'touchscreen':
              touchscreens.push(cat);
              break;
            case 'budget':
              budgets.push(cat);
              break;
            case 'brand':
              brands.push(cat);
              break;
            default:
              console.error(`Unknown filter category found:${cat.type}`);
              break;
          }
        }
      }
    }

    // step2
    for (const f of this.props.step2) {
      if (f.selected) {
        budgets.push(f);
      }
    }

    // step3
    // ignore 1st index b/c the brand is 'I don't care'
    for (let i=1; i<this.props.step3.length-1; i++) {
      if (this.props.step3[i].selected) {
        brands.push(this.props.step3[i]);
      }
    }
    if (this.props.step3[5].selected) {
      brands.push({selected: true, text: this.props.step3[5].otherValue});
    }

    // step4
    for (let i=0; i<this.props.step4.attributes.length; i++) {
      if (this.props.step4.attributes[i].selected) {
        switch (this.props.filterCategories.others[i].type) {
          case 'weight':
            weights.push(this.props.filterCategories.others[i]);
            break;
          case 'screenSize':
            screenSizes.push(this.props.filterCategories.others[i]);
            break;
          case 'touchscreen':
            touchscreens.push(this.props.filterCategories.others[i]);
            break;
          default:
            console.log(`attribute not yet implemented: ${this.props.filterCategories.others[i].type}`);
            break;
        }
      }
    }
    for (const color of this.props.step4.colors) {
      if (color.selected) {
        colors.push(color);
        break;
      }
    }

    // squish
    for (const s of ramSizes) {
      if (s.sign === '>' && s.value > filtersOptimized.ramSize.min) {
        filtersOptimized.ramSize.min = s.value;
      } else if (s.sign === '<' && s.value < filtersOptimized.ramSize.max) {
        // should be rare b/c ppl never want an upper limit on ram
        filtersOptimized.ramSize.max = s.value;
      }
    }
    if (hardDriveTypes.length) {
      filtersOptimized.hardDriveType = 'SSD';
    }
    for (const s of hardDriveSpaces) {
      if (s.sign === '>' && s.value > filtersOptimized.hardDriveSpace.min) {
        filtersOptimized.hardDriveSpace.min = s.value;
      } else if (s.sign === '<' && s.value < filtersOptimized.hardDriveSpace.max) {
        // should be rare b/c ppl never want an upper limit on space
        filtersOptimized.hardDriveSpace.max = s.value;
      }
    }
    for (const s of screenSizes) {
      if (s.sign === '>' && s.value > filtersOptimized.screenSize.min) {
        filtersOptimized.screenSize.min = s.value;
      } else if (s.sign === '<' && s.value < filtersOptimized.screenSize.max) {
        filtersOptimized.screenSize.max = s.value;
      }
    }
    if (screenTypes.length) {
      filtersOptimized.screenType = 'IPS';
    }
    for (const s of cpuCores) {
      if (s.sign === '>' && s.value > filtersOptimized.cpuCores.min) {
        filtersOptimized.cpuCores.min = s.value;
      } else if (s.sign === '<' && s.value < filtersOptimized.cpuCores.max) {
        // should be rare b/c ppl never want an upper limit on cpu cores
        filtersOptimized.cpuCores.max = s.value;
      }
    }
    if (gpuTypes.length) {
      filtersOptimized.gpuType = 'Discrete';
    }
    for (const s of ramSizes) {
      if (s.sign === '>' && s.value > filtersOptimized.ramSize.min) {
        filtersOptimized.ramSize.min = s.value;
      } else if (s.sign === '<' && s.value < filtersOptimized.ramSize.max) {
        // should be rare b/c ppl never want an upper limit on ram
        filtersOptimized.ramSize.max = s.value;
      }
    }
    for (const s of weights) {
      if (s.sign === '>' && s.value > filtersOptimized.weight.min) {
        // should be rare b/c ppl never want a lower limit on limit (unless it's brick)
        filtersOptimized.weight.min = s.value;
      } else if (s.sign === '<' && s.value < filtersOptimized.weight.max) {
        filtersOptimized.weight.max = s.value;
      }
    }
    if (touchscreens.length) {
      filtersOptimized.touchscreen = true;
    }
    budgets.forEach(b => filtersOptimized.budgets.push(b.range));
    brands.forEach(b => filtersOptimized.brands.push(b.text));
    if (colors.length) {
      filtersOptimized.color = colors[0];
    }

    window.mixpanel.track('Done Clicked', {
      filtersOptimized: filtersOptimized,
      step1: this.props.step1,
      step2: this.props.step2,
      step3: this.props.step3,
      step4: this.props.step4
    });

    this.props.updateLaptopQuizPageFiltersSquished(filtersOptimized);
    this.props.history.push('/laptopresults');
  }

  handleBrandTextBoxChange(event) {
    const currentStep3 = this.props.step3.slice();
    currentStep3[5]['otherValue'] = event.target.value;
    this.props.updateLaptopQuizPageStep3(currentStep3);

  }

  toggleSelectedAndDeselectEverythingElse(arr, idx) {
    const newArray = arr.slice();
    const newVal = arr[idx]['selected'];
    newArray.forEach(element => element.selected = false);
    newArray[idx]['selected'] = !newVal;
    return newArray;
  }

  render() {
    return (
      <div className="Regular-page ui centered grid">
        <div className="three column row">
          <div className="one wide column">
          </div>

          <div className="ten wide column center aligned">

            <h1 id="Step1Heading" className="permutize-color">Laptop Genie</h1>

            <h2>Step 1/4</h2>
            <Progress color="blue" value="1" total="4" progress="ratio" />

            <h2>What is it going to be used for? Select all that apply.</h2>

            <Button.Group vertical>

              {this.props.step1.map((element, idx) =>
                <Button key={idx} name={idx} onClick={this.handleStep1ButtonClick} basic color={element.selected ? "green": "grey"} size="huge" icon labelPosition="left">
                  <Icon name="checkmark" />
                  {this.props.step1[idx].text}
                </Button>
              )}

            </Button.Group>

            <br/>
            <br/>

            <Button basic color="grey" size="huge" onClick={this.handleStep1NextButtonClick}>
              Next
            </Button>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>

            <h1 id="Step2Heading" className="permutize-color">Laptop Genie</h1>

            <h2>Step 2/4</h2>
            <Progress color="blue" value="2" total="4" progress="ratio" />

            <h2>What is your budget?</h2>

            <Button.Group vertical>

              {this.props.step2.map((element, idx) =>
                <Button key={idx} name={idx} onClick={this.handleStep2ButtonClick} basic color={element.selected ? "green": "grey"} size="huge" icon labelPosition="left">
                  <Icon name="checkmark" />
                  {this.props.step2[idx].text}
                </Button>
              )}

            </Button.Group>

            <br/>
            <br/>

            <Button basic color="grey" size="huge" onClick={this.handleStep2NextButtonClick}>
              Next
            </Button>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>

            <h1 id="Step3Heading" className="permutize-color">Laptop Genie</h1>

            <h2>Step 3/4</h2>
            <Progress color="blue" value="3" total="4" progress="ratio" />

            <h2>Are there specific brands you prefer?</h2>

            <Button.Group vertical>

              {this.props.step3.map((element, idx) =>
                <Button key={idx} name={idx} onClick={this.handleStep3ButtonClick} basic color={element.selected ? "green": "grey"} size="huge" icon labelPosition="left">
                  <Icon name="checkmark" />
                  {this.props.step3[idx].text}
                </Button>
              )}

            </Button.Group>

            <br/>
            <br/>

            <Input error={this.props.step3[5].errorState} value={this.props.step3[5].otherValue} onChange={this.handleBrandTextBoxChange} size="huge" placeholder="If other, please specify" />
            <br/>
            {this.props.step3[5].errorState && <Label pointing color="red">Please enter a value</Label>}
            <br/>
            <br/>



            <br/>
            <br/>

            <Button basic color="grey" size="huge" onClick={this.handleStep3NextButtonClick}>
              Next
            </Button>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>

            <h1 id="Step4Heading" className="permutize-color">Laptop Genie</h1>

            <h2>Step 4/4</h2>
            <Progress color="blue" value="4" total="4" progress="ratio" />

            <h2>Select all that are important to you.</h2>

            <Label.Group>

              {this.props.step4.attributes.map((element, idx) =>
                <Label as="a" key={idx} name={idx} onClick={this.handleStep4AttributesButtonClick} color={element.selected ? "green": "grey"}>
                  {element.text}
                  <Icon name="close" className={element.selected ? "show-x" : "not-show-x"}/>
                </Label>
              )}

            </Label.Group>

            <br/>
            <Label>Color:</Label>
            <Button.Group>

              {this.props.step4.colors.map((element, idx) =>
                <Button key={idx} name={idx} onClick={this.handleStep4ColorsButtonClick} color={element.selected ? "green": undefined}>
                  {element.text}&nbsp;&nbsp;<Icon name="close" className={element.selected ? "show-x" : "not-show-x"}/>
                </Button>
              )}

            </Button.Group>

            <br/>
            <br/>

            <Button basic color="green" size="huge" onClick={this.handleStep4DoneButtonClick}>
              Done
            </Button>

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>

          </div>

          <div className="one wide column">
          </div>
        </div>


      </div>
    );
  }
}

export default connect(
  (state) => ({
    currentStep: state.laptopQuizPage.currentStep,
    step1: state.laptopQuizPage.step1,
    step2: state.laptopQuizPage.step2,
    step3: state.laptopQuizPage.step3,
    step4: state.laptopQuizPage.step4,
    filterCategories: state.laptopQuizPage.filterCategories,
    filtersSquished: state.laptopQuizPage.filtersSquished
  }),
  {
    updateLaptopQuizPageCurrentStep,
    incrementLaptopQuizPageCurrentStep,
    updateLaptopQuizPageStep1,
    updateLaptopQuizPageStep2,
    updateLaptopQuizPageStep3,
    updateLaptopQuizPageStep4,
    updateLaptopQuizPageFiltersSquished
  }
)(LaptopQuizPage);


// WEBPACK FOOTER //
// ./src/components/LaptopQuizPage/LaptopQuizPage.js